import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Switch from '@carvana/showroom-forms/Switch';
import styled from 'styled-components';
import { financingTermsOperations, financingTermsSelectors } from '../../ducks';

export const NameText = styled.p`
  color: var(--cvna-color-blue-6);
  padding-right: 16px;
  margin-bottom: 0;
  grid-area: nameText;
`;

const CoSignerTerms = () => {
  const financingTermsOverview = useSelector(financingTermsSelectors.getFinancingTermsOverview);
  const isLoadingTermsOverview = useSelector(financingTermsSelectors.getIsLoadingTermsOverview);
  const coApplicantInfo =
    financingTermsOverview?.coApplicant?.firstName && financingTermsOverview?.coApplicant;

  const dispatch = useDispatch();

  const handleToggle = () => {
    dispatch(financingTermsOperations.postToggleCoApplicant());
  };

  return (
    <>
      {coApplicantInfo && (
        <NameText className="nameText">{`${coApplicantInfo?.firstName} ${financingTermsOverview.coApplicant?.lastName}`}</NameText>
      )}
      <Switch
        disabled={isLoadingTermsOverview}
        onChange={handleToggle}
        checked={financingTermsOverview?.coApplicantToggleOn}
        className="coApplicantToggle"
      />
    </>
  );
};
export default CoSignerTerms;
